import type { JSX } from "solid-js";

/** Figma: the 50 px map buttons (menu) sit 8 px under the 54 px status bar. */
export const MAP_TOP = "max(1rem, calc(env(safe-area-inset-top) + 8px))";

/**
 * Figma 68:10148: the itinerary step banner and the map notices share the menu button's row
 * (12 px from the left edge, up to 8 px before the 50 px button) instead of sitting under it.
 */
export function MapTopRow(props: { children: JSX.Element }) {
  return (
    <div
      class="pointer-events-none absolute left-3 right-[69px] z-10 flex min-h-[50px] flex-col justify-center gap-2 [&>*]:pointer-events-auto"
      style={{ top: MAP_TOP }}
    >
      {props.children}
    </div>
  );
}
